import { ListResponsePageUrlKeywordsBean } from 'common/api/api'
import { dictionaryApi } from 'common/api/entitiesApi'
import { ListCard } from 'common/components/ListCard'
import { SearchInput } from 'common/components/SearchInput'
import { ListFilters, useAppContext } from 'common/context/AppContext'
import { CommonRoutes } from 'common/context/commonRoutes'
import { initListFilters, useListFilters } from 'common/util/useListFilters'
import { apiCall, camelCaseToWords } from 'common/util/Util'
import { Typography } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'

const ContextualTargetingList = () => {

    const appContext = useAppContext()
    const [filters, setFilters] = useState<ListFilters>(initListFilters())
    const { setFilter } = useListFilters(setFilters)
    const [loading, setLoading] = useState<boolean>(false)
    const [listData, setListData] = useState<ListResponsePageUrlKeywordsBean>()

    const loadData = () => {
        apiCall(setLoading, appContext,
            () => dictionaryApi.pageUrlKeywords(
                filters.pageUrlSearch,
                filters.keywordSearch,
                filters.brandSafetySearch,
                { query: { page: filters.page, size: filters.pageSize } }
            ),
            (data) => setListData(data)
        )
    }

    return (
        <ListCard loading={loading} title="Contextual Targeting"
            listRouteKey={CommonRoutes.CONTEXTUAL_TARGETING}
            filters={filters} setFilters={setFilters}
            listData={listData}
            loadData={loadData}
            tableLayout="fixed"
            scrollX={1300}
            columns={[
                {
                    title: "Page URL",
                    dataIndex: "pageUrl",
                    className: "list-table-name",
                    align: "left",
                    ellipsis: true,
                    width: 450,
                    render: (pageUrl: string) => pageUrl && (
                        <Typography.Link
                            href={pageUrl}
                            target="_blank"
                            rel="noreferrer"
                            title={pageUrl}
                            style={{ color: '#5888CF', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                            ellipsis
                        >
                            {pageUrl}
                        </Typography.Link>
                    )
                }, {
                    title: "Keywords",
                    dataIndex: "keywords",
                    className: "list-table-name",
                    align: "left",
                    width: 380,
                    render: (keywords: string[]) => keywords?.join(', ')
                }, {
                    title: "Brand Safety",
                    dataIndex: "brandSafety",
                    className: "list-table-name",
                    align: "left",
                    width: 280,
                    render: (brandSafety: string[]) => brandSafety?.map(camelCaseToWords).join(', ')
                }, {
                    title: "Processed At",
                    dataIndex: "processedAt",
                    width: 140,
                    render: (date) => date && dayjs(date).format('DD MMM YY HH:mm')
                }
            ]}
        >
            <SearchInput
                value={filters.pageUrlSearch}
                onChange={(value) => setFilter('pageUrlSearch', value)}
                placeholder="Search by Page URL"
                width="260px"
            />
            <SearchInput
                value={filters.keywordSearch}
                onChange={(value) => setFilter('keywordSearch', value)}
                placeholder="Search by Keywords"
                width="260px"
            />
            <SearchInput
                value={filters.brandSafetySearch}
                onChange={(value) => setFilter('brandSafetySearch', value)}
                placeholder="Search by Brand Safety"
                width="260px"
            />
        </ListCard>
    )
}

export default ContextualTargetingList
